module.exports = __webpack_public_path__ + "img/frame (77).6b0883b9.jpg";